import * as React from 'react';

/**
 * Return the stored value in last render. Return undefined in first render.
 *
 * @template T
 * @param {T} value - The value to store.
 * @returns {T|undefined} The value in last render.
 */
export function usePrevious<T>(value: T): T | undefined {
    const ref = React.useRef<T>();

    React.useEffect(() => {
        ref.current = value;
    }, [value]);

    return ref.current;
}